import { RETURNS_CSS } from './returnsSeed.js'

export const FINAL_SALE_SLUG = 'final-sale-items'
export const FINAL_SALE_PATH = '/final-sale-items'
export const FINAL_SALE_CSS = RETURNS_CSS

export const FINAL_SALE_HTML = `<div class="sp-page">
  <h1 class="sp-title">Final Sale Items</h1>
  <div class="sp-intro">
    The products below are Final Sale. They cannot be returned or exchanged.
  </div>
  <h2 class="sp-heading">Antiseptics and first aid</h2>
  <ul class="sp-list">
    <li>Hydrogen Peroxide 2 oz Antiseptic Spray by Dynarex</li>
    <li>Hydrogen Peroxide 3%, 8 oz</li>
    <li>Hydrogen Peroxide Spray Bottle, 10 oz</li>
    <li>Hydrogen Peroxide 3%, 16 oz</li>
    <li>Isopropyl Rubbing Alcohol, 4 oz, 2/pack</li>
    <li>Isopropyl Alcohol 70%, 16 oz</li>
    <li>Povidone-Iodine, 4 oz</li>
    <li>Povidone Iodine, 16 oz</li>
    <li>Betasept Dyna-Hex 4% CHG Scrub, 4 oz</li>
    <li>Witch Hazel, 16 oz</li>
    <li>Premium Hand Sanitizer with Aloe, 8 oz</li>
    <li>Foaming Hand Sanitizer with Aloe, 8 oz</li>
    <li>DermoPlast First Aid Antibacterial Spray, 2.75 oz</li>
  </ul>
  <h2 class="sp-heading">Single-use and hygiene supplies</h2>
  <ul class="sp-list">
    <li>Alcohol Prep Pad, each</li>
    <li>Cotton Balls</li>
    <li>Q-Tips, bag of 25</li>
    <li>OB Towelette, each</li>
    <li>Peri Bottle, each</li>
    <li>Disposable Postpartum Underwear, Medium, each</li>
    <li>Disposable Postpartum Underwear, Large, each</li>
    <li>Disposable Postpartum Underwear, X-Large, each</li>
    <li>Peach Contoured Postpartum Pad, each</li>
    <li>ContourPlus Maxi Pad, 8" x 17", each</li>
    <li>Commemorative Keepsake Birth Certificate, each</li>
    <li>Small Nitrile Non-Sterile Gloves, Bag of 25</li>
    <li>Medium Nitrile Non-Sterile Gloves, Bag of 25</li>
    <li>Large Nitrile Non-Sterile Gloves, Bag of 25</li>
    <li>Medium Latex Non-Sterile Gloves, Bag of 25</li>
    <li>Gauze Sponge 4 x 4 Non-Sterile, 10 Sponges</li>
  </ul>
  <h2 class="sp-heading">Household items</h2>
  <ul class="sp-list">
    <li>Drinking Straws</li>
    <li>Drawstring Trash Bag, 13 gallon</li>
    <li>Drawstring Trash Bag, 33 gallon</li>
    <li>Heavy Duty Trash Bag, 50 gallon</li>
    <li>Gallon Freezer Bag</li>
    <li>Ziploc Slider Gallon Freezer Bag</li>
    <li>Bag, 1 pint</li>
    <li>Ultra Strong Paper Towel Roll</li>
    <li>VIVA Paper Towels</li>
  </ul>
  <h2 class="sp-heading">Dry herbs (1 ounce)</h2>
  <ul class="sp-list">
    <li>Calendula Flower Petals</li>
    <li>Chamomile</li>
    <li>Comfrey Leaf</li>
    <li>Comfrey Root</li>
    <li>Echinacea Purpurea Herb</li>
    <li>Lavender Flowers</li>
    <li>Plantain Leaf</li>
    <li>Red Raspberry Leaf</li>
    <li>Sage Leaf, Organic</li>
    <li>Shepherd's Purse</li>
    <li>St. John's Wort</li>
    <li>Uva Ursi Leaves</li>
    <li>Wildcrafted Goldenseal Leaf</li>
    <li>Witch Hazel Bark</li>
    <li>Witch Hazel Leaf</li>
    <li>Dry Yarrow Flowers</li>
  </ul>
  <h2 class="sp-heading">Herbal baths</h2>
  <ul class="sp-list">
    <li>Herbal Afterbirth Sitz Bath, dry herb soak with salt, 12 oz</li>
    <li>Soothing Herbal Bath, 12 oz</li>
  </ul>
  <h2 class="sp-heading">Breast pumps</h2>
  <ul class="sp-list">
    <li>Haakaa Manual Breast Pump, 4 oz, Gen. 1</li>
    <li>Haakaa Silicone Manual Breast Pump, 4 oz, Gen. 2</li>
    <li>Haakaa Generation 3 Silicone Breast Pump and Bottle Top Set, Peach</li>
    <li>The Luna Double Electric Breast Pump with Battery by Motif Medical</li>
    <li>Zomee Double Electric Breast Pump</li>
    <li>Spectra S2 Plus Premier Electric Breast Pump</li>
    <li>Medela Pump in Style Pro Breast Pump, 2nd Gen.</li>
  </ul>
  <h2 class="sp-heading">Olive oil</h2>
  <ul class="sp-list">
    <li>Organic Extra Virgin Olive Oil Packet</li>
    <li>Olive Oil, 3.8 ounce bottle</li>
    <li>Olive Oil, 1 oz. Dropper Bottle</li>
  </ul>
</div>`

export function finalSaleItemsSeedDocument() {
	const now = new Date()
	return {
		slug: FINAL_SALE_SLUG,
		path: FINAL_SALE_PATH,
		title: 'Final Sale Items',
		metaTitle: 'Final Sale Items | In His Hands Birth Supply',
		status: 'published',
		draftHtml: FINAL_SALE_HTML,
		draftCss: FINAL_SALE_CSS,
		publishedHtml: FINAL_SALE_HTML,
		publishedCss: FINAL_SALE_CSS,
		publishedAt: now,
		publishedBy: '',
		chats: [],
		activeChatId: '',
		created: now,
		updated: now,
	}
}
